<p-confirmPopup></p-confirmPopup>
<custom-table [config]="customTable">
</custom-table>